var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M18.984 2.6q.816 0 1.416.6t.6 1.416v13.968q0 .816-.6 1.416t-1.416.6H5.016q-.84 0-1.428-.6A1.96 1.96 0 0 1 3 18.584V14.6h2.016v3.984h13.968V4.616H5.016V8.6H3V4.616Q3 3.8 3.588 3.2t1.428-.6zM10.08 15.2l2.568-2.616H3v-1.968h9.648L10.08 8l1.416-1.416 5.016 5.016-5.016 5.016z"
})));
export default SvgLogOut;